<template>
    <div class="gp-app-reserve-mask">
        <div class="gp-app-reserve-mask__cancel-reserve-dialog dialog-size">
            <div class="words">取消预约后将无法获得专属福利，确定要放弃预约吗？</div>
            <div class="operation">
                <div class="confirm" @click="confirm">确定</div>
                <div class="close" @click="close">暂不取消</div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api';

export default {
    props: {
        appDoc: {
            type: Object,
            required: true,
        },
        index: {
            type: Number,
        },
    },
    methods: {
        confirm() {
            let params = {
                data: {
                    app_id: this.appDoc?.appId,
                    iphone: this.appDoc?.iphone || '',
                },
            };
            api.newdetail.cancelBooked(params).then(res => {
                if (+res.isAppointment === 1) {
                    this.$emit('closeCancelMask', 1);
                }
                else {
                    this.$toast('取消失败，请重试');
                    this.$emit('closeCancelMask', 0);
                }
            }).catch(err => {
                this.$toast('取消失败，请重试');
                this.$emit('closeCancelMask', 0);
                console.log(err);
            });
            this.doDialogClickLog('determine', '取消预约');

        },
        close() {
            this.$emit('closeCancelMask', 0);
        },
    },
};
</script>

<style scoped lang="scss" scope>
    @import "~@/common/style/mixin/utils";
    @import "~@/common/style/mixin/mixins";
    @import "~@/common/style/mixin/border";

    @include b(app-reserve-mask) {
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        z-index: 99;
        background: rgba(153,153,153,0.5);
        display: flex;
        overflow: hidden;
        justify-content: center;
        align-items: center;
        text-align: center;
        .title {
            padding-top: 70px;
            font-size: 72px;
        }
        .words {
            line-height: 78px;
            font-size: 48px;
            color: #999;
            padding: 0 60px;
        }
        .dialog-size {
            width: 993px;
            background-color: #fff;
            border-radius: 39px;
            position: relative;
        }
        @include e(cancel-reserve-dialog) {
           height: 450px;
           .words {
               padding: 70px 120px;
           }
           .operation {
                position: absolute;
                bottom: 0;
                width: 993px;
                height: 144px;
                line-height: 144px;
                font-size: 54px;
                border-top: 1px solid #e0e0e0;
                .confirm {
                    width: 492px;
                    float: left;
                    border-right: 1px solid #e0e0e0;
                }
                .close {
                    color: #38f;
                }
           }
        }
    }
</style>